import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

const colorSchemes = {
  blue: {
    iconColor: 'text-blue-500',
    verified: 'bg-green-100 text-green-800',
    partial: 'bg-yellow-100 text-yellow-800',
    pending: 'bg-slate-100 text-slate-800',
    progressBar: 'bg-blue-500',
    referralText: 'text-blue-600',
    referralBg: 'bg-blue-50'
  },
  green: {
    iconColor: 'text-green-500',
    verified: 'bg-green-100 text-green-800',
    partial: 'bg-yellow-100 text-yellow-800',
    pending: 'bg-slate-100 text-slate-800',
    progressBar: 'bg-green-500',
    referralText: 'text-green-600',
    referralBg: 'bg-green-50'
  },
  violet: {
    iconColor: 'text-violet-500',
    verified: 'bg-green-100 text-green-800',
    partial: 'bg-yellow-100 text-yellow-800',
    pending: 'bg-slate-100 text-slate-800',
    progressBar: 'bg-violet-500',
    referralText: 'text-violet-600',
    referralBg: 'bg-violet-50'
  }
};

const VerificationSidebar = ({ profile, badges = [], color = 'blue' }) => {
  const scheme = colorSchemes[color] || colorSchemes.blue;
  const verifiedCount = badges.filter(b => b.status === 'verified').length;
  const totalCount = Math.max(badges.length, 1);

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm"
      data-testid="verification-sidebar"
    >
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck className={`h-6 w-6 ${scheme.iconColor}`} />
        <h2 className="font-heading text-lg font-bold text-slate-900">Status Tracker</h2>
      </div>
      <div className="space-y-4">
        <div>
          <p className="text-sm text-slate-600 mb-1">Verification Status</p>
          <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium capitalize ${
            profile?.verification_status === 'verified' ? scheme.verified :
            profile?.verification_status === 'partial' ? scheme.partial :
            scheme.pending
          }`}>
            {profile?.verification_status || 'Pending'}
          </span>
        </div>
        {badges.length > 0 && (
          <div>
            <p className="text-sm text-slate-600 mb-1">Credentials</p>
            <div className="flex items-center gap-2">
              <div className="flex-1 bg-slate-200 rounded-full h-2">
                <div 
                  className={`${scheme.progressBar} h-2 rounded-full`}
                  style={{ width: `${(verifiedCount / totalCount) * 100}%` }}
                ></div>
              </div>
              <span className="text-sm font-medium text-slate-700">
                {verifiedCount}/{badges.length}
              </span>
            </div>
          </div>
        )}
        <div>
          <p className="text-sm text-slate-600 mb-1">Membership</p>
          <p className="font-medium text-slate-900 capitalize">{profile?.membership_tier || 'Free'}</p>
        </div>
        <div className="pt-4 border-t border-slate-200">
          <p className="text-sm text-slate-600 mb-1">Referral Code</p>
          <code className={`font-mono text-sm font-bold ${scheme.referralText} ${scheme.referralBg} px-3 py-1 rounded block text-center`}>
            {profile?.referral_code}
          </code>
        </div>
      </div>
    </motion.div>
  );
};

export default VerificationSidebar;
